import * as actionTypes from '../ActionTypes';
import {FETCH_FILTERS_OPTION} from "../ActionTypes";

const initialState = {
	products: [],
	pageInfo: null,
	stateProd: [],
	selectedProduct: null,
	loading: false,
	error: null,
	filters: {
		q: '',
		category: '',
		subcategory: '',
		brand: '',
		cat_id: [],
		sub_cat_id: [],
		brand_id: [],
		country_id: [],
		diet_id: [],
		dietary: '',
		country: '',
		max: 1000,
		min: 0,
		promotion: false,
		oos: false,
		sort: 'a-z'
	},
	pagination: {
		currentPage: 1,
		totalPages: 1,
		totalItems: 0,
		itemsPerPage: 25
	},
	showFilter: false,
	filterOptions: {
		categories: [],
		subcategories: [],
		brands: [],
		dietary: [],
		countries: [],
		priceRange: {min: 0, max: 1000}
	}
};

export const productSlice = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.FETCH_PRODUCTS_REQUEST:
			return {
				...state,
				products: state.pagination.currentPage > 1 ? state.products : [],
				loading: true,
				error: null
			};

		case actionTypes.SET_PAGE_INFO:
			return {
				...state,
				pageInfo: action.payload
			}
		case actionTypes.FETCH_PRODUCTS_SUCCESS:
			return {
				...state,
				loading: false,
				products: action.payload.append
					? [...state.products, ...action.payload.products]
					: action.payload.products,
				pagination: {
					...state.pagination,
					...action.payload.pagination,
				},
				error: null
			};

		case actionTypes.FETCH_FILTERS_OPTION:
			return {
				...state,
				filterOptions: action.payload || state.filterOptions,
			};

		case actionTypes.FETCH_PRODUCTS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				products: state.pagination.currentPage > 1 ? state.products : []
			};

		case actionTypes.SET_FILTERS:
			return {
				...state,
				filters: {
					...state.filters,
					...action.payload
				},
				pagination: {
					...state.pagination,
					currentPage: 1
				}
			};

		case actionTypes.SET_SEARCH:
			return {
				...state,
				filters: {
					...state.filters,
					q: action.payload
				},
				pagination: {
					...state.pagination,
					currentPage: 1
				}
			};

		case actionTypes.SET_CATEGORY:
			return {
				...state,
				filters: {
					...state.filters,
					category: action.payload
				},
				pagination: {
					...state.pagination,
					currentPage: 1
				}
			};

		case actionTypes.SET_SUBCATEGORY:
			return {
				...state,
				filters: {
					...state.filters,
					subcategory: action.payload
				},
				pagination: {
					...state.pagination,
					currentPage: 1
				}
			};

		case actionTypes.SET_BRAND:
			return {
				...state,
				filters: {
					...state.filters,
					brand: action.payload
				},
				pagination: {
					...state.pagination,
					currentPage: 1
				}
			};

		case actionTypes.SET_COUNTRY:
			return {
				...state,
				filters: {
					...state.filters,
					country_id: Array.isArray(action.payload)
						? action.payload
						: [action.payload]
				},
				pagination: {
					...state.pagination,
					currentPage: 1
				}
			};

		case actionTypes.SET_DIETARY:
			return {
				...state,
				filters: {
					...state.filters,
					diet_id: Array.isArray(action.payload)
						? action.payload
						: [action.payload]
				},
				pagination: {
					...state.pagination,
					currentPage: 1
				}
			};

		case actionTypes.SET_PRICE_RANGE:
			return {
				...state,
				filters: {
					...state.filters,
					min: action.payload.min || 0,
					max: action.payload.max || 1000
				},
				pagination: {
					...state.pagination,
					currentPage: 1
				}
			};

		case actionTypes.SET_SORT:
			return {
				...state,
				filters: {
					...state.filters,
					sort: action.payload
				}
			};

		case actionTypes.CLEAR_FILTERS:
		case actionTypes.RESET_FILTERS:
			return {
				...state,
				filters: {
					...initialState.filters,
					// Keep category and subcategory if they're from route params
					category: state.filters.category,
					subcategory: state.filters.subcategory,
				},
				pagination: {
					...state.pagination,
					currentPage: 1
				}
			};

		case actionTypes.SET_PAGE:
			return {
				...state,
				pagination: {
					...state.pagination,
					currentPage: action.payload
				}
			};

		case actionTypes.RESET_PAGE:
			return {
				...state,
				pagination: {
					...state.pagination,
					currentPage: action.payload || 1
				}
			};

		case actionTypes.TOGGLE_FILTERS:
			return {
				...state,
				showFilter: !state.showFilter
			};

		default:
			return state;
	}
};